module.exports = __webpack_public_path__ + "img/1 (47).3d37f278.png";